import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { searchFilesByModule } from "../../services/FilesService/FilesService";
import toast from "react-hot-toast";
import SimpleLoader from "../../components/Loader/SimpleLoader";
import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import PdfFlipBook from "../../components/PdfFlipBook/PdfFlipBook";

const ErtegiDetail = () => {
  const { uuid } = useParams();
  const [ertegi, setErtegi] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchErtegi = async () => {
      try {
        const response = await searchFilesByModule({
          module_code: "ertegiler",
        });
        const match = response?.files?.find((file) => file.uuid === uuid);
        if (match) {
          setErtegi(match);
        } else {
          toast.error("Ертегі табылмады.");
        }
      } catch (err) {
        toast.error("Қате орын алды.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchErtegi();
  }, [uuid]);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-20">
        <SimpleLoader className="w-10 h-10 text-[#674DA2]" />
      </div>
    );
  }

  if (!ertegi) {
    return (
      <div className="text-center text-gray-600 mt-10">Ертегі табылмады.</div>
    );
  }

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <button
        onClick={() => navigate("/ertegiler")}
        className="flex items-center text-[#674DA2] mb-4 hover:underline"
      >
        <ArrowLeftIcon className="w-5 h-5 mr-1" />
        Артқа
      </button>
      <h1 className="text-2xl md:text-3xl font-bold text-[#674DA2] mb-6 text-center">
        {ertegi.label || "Ертегі"}
      </h1>
      {ertegi.file_name?.toLowerCase().endsWith(".pdf") ? (
        <PdfFlipBook url={ertegi.file_url} title={ertegi.label} />
      ) : (
        <div className="rounded-xl overflow-hidden shadow-lg">
          <img
            src={ertegi.file_url}
            alt={ertegi.label}
            className="w-full object-contain"
          />
        </div>
      )}
    </div>
  );
};

export default ErtegiDetail;
